import type {ActivityVersion} from "./activity-library";

export const DOPPLER_RIPPLE_URL =
  "/interactive-assets/doppler/ripple-tank.html?v=20260923-1";

export function withCurrentDopplerRuntimeAssets(version: ActivityVersion): ActivityVersion {
  if (version.id !== "reference-doppler" || !version.package) return version;

  const packageClone = structuredClone(version.package);
  const rippleBlock = packageClone.interactive.blocks.find(
    (block) => block.id === "ripple-tank-block",
  );
  if (!rippleBlock || rippleBlock.type !== "simulation") return version;

  rippleBlock.assetId = "ripple-tank";
  const asset = packageClone.interactive.assets.find(
    (candidate) => candidate.id === "ripple-tank",
  );
  if (asset) {
    asset.kind = "simulation";
    asset.name = "Cuve à ondes — source fixe/mobile";
    asset.mimeType = "text/html";
    asset.url = DOPPLER_RIPPLE_URL;
  } else {
    packageClone.interactive.assets.push({
      id: "ripple-tank",
      kind: "simulation",
      name: "Cuve à ondes — source fixe/mobile",
      mimeType: "text/html",
      url: DOPPLER_RIPPLE_URL,
    });
  }

  return {...version, package: packageClone};
}
